<template>
	<div class="app__loader">
		<ProgressSpinner />
	</div>
</template>

<script setup>
import ProgressSpinner from 'primevue/progressspinner';
</script>

<script>
export default {
	name: 'UiLoader',
};
</script>
